import React from "react";
import { useMutation } from "@apollo/client";
import pretty from "Shared/pretty";
import mutations from "Shared/mutations";
import { ApprovalAction } from "Shared/types/ApprovalActions";
import { handleValidationErrors } from "Modules/HandleValidationErrors";
import { successToast, errorToast } from "Modules/DPToast";
import {
  ApprovalActionsCell,
} from "Components/Shared/ApprovalActionsCell/ApprovalActionsCell";
import {
  UpdateRewardMutation,
  UpdateRewardMutationVariables,
} from "generated/graphql";

export interface RewardActionsProps {
  employeeFullName: string;
  totalAmountCents: number;
  rewardId: string;
  employerId: string;
  actions: ApprovalAction[];
}

export const RewardActions = ({
  employeeFullName,
  totalAmountCents,
  rewardId,
  employerId,
  actions,
}: RewardActionsProps) => {
  const [updateReward] = useMutation<UpdateRewardMutation, UpdateRewardMutationVariables>(
    mutations.UPDATE_REWARD,
  );

  const onConfirmAction = async (action: ApprovalAction) => {
    try {
      const response = await updateReward({
        variables: {
          approved: action === ApprovalAction.approve,
          rewardId,
          approverId: employerId,
        }
      });

      if (response?.data?.updateReward.message) {
        successToast(response.data.updateReward.message, false);
      }
    } catch (err) {
      if (
        err.networkError &&
        err.networkError.result.length &&
        err.networkError.response.status === 403
      ) {
        errorToast(err.networkError.result[0].message);
      } else {
        handleValidationErrors(err);
      }
    }
  };

  const getModalText = (action: ApprovalAction) => {
    switch (action) {
    case ApprovalAction.approve:
      return `Click "Approve Reward" to confirm the reward of
        ${pretty.dollar(totalAmountCents)} to ${employeeFullName}`;
    case ApprovalAction.reject:
      return "Click \"Reject Reward\" to confirm you are rejecting this reward";
    case ApprovalAction.cancel:
      return "Are you sure you want to cancel this reward to the employee?";
    }
  };

  const getButtonText = (action: ApprovalAction) => {
    return  action === ApprovalAction.approve || action === ApprovalAction.reject
      ? `${action.toLowerCase()} reward`
      : "Yes";
  };

  const getQuitButtonText = (action: ApprovalAction) => {
    return  action === ApprovalAction.approve || action === ApprovalAction.reject
      ? "Cancel"
      : "No";
  };

  return (
    <ApprovalActionsCell
      actions={actions}
      getModalText={getModalText}
      getButtonText={getButtonText}
      getQuitButtonText={getQuitButtonText}
      onConfirmAction={onConfirmAction}
    />
  );
};

